import { render, staticRenderFns } from "./orderApproval.vue?vue&type=template&id=73c0314e&scoped=true"
import script from "./orderApproval.vue?vue&type=script&lang=js"
export * from "./orderApproval.vue?vue&type=script&lang=js"
import style0 from "./orderApproval.vue?vue&type=style&index=0&id=73c0314e&prod&scoped=true&lang=css"
import style1 from "./orderApproval.vue?vue&type=style&index=1&id=73c0314e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c0314e",
  null
  
)

export default component.exports